module.exports = __webpack_public_path__ + "static/media/icons_epaule.768ae516.svg";